import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { THEME, PALETTE } from "@/lib/themePalette";

// Тема на разметке. index.html написан в голубом варианте — он же дефолт, —
// поэтому на sky здесь не выполняется ничего и рф не меняется. Сиреневая
// сборка доставляет тему тремя штрихами: атрибут для CSS-переменных каркаса,
// цвет адресной строки и иконки из папки своей темы.
if (THEME !== "sky") {
  document.documentElement.setAttribute("data-theme", THEME);
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.setAttribute("content", PALETTE.theme[500]);
  document.querySelectorAll('link[rel~="icon"]').forEach((link) => {
    const file = (link.getAttribute("href") || "").split("/").pop();
    if (file) link.setAttribute("href", `/theme/${THEME}/${file}`);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
